module.exports = __webpack_public_path__ + "images/screen-shots/forms-ce4c7a525169b4f3c2f436873eff81c6.png";